import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import { unwrap } from '@/lib/api/request';

export function useSubscribe() {
  return useMutation({
    mutationFn: (email: string) => unwrap(api.POST('/newsletter/subscribe', { body: { email } })),
  });
}

export function useConfirmSubscription() {
  return useMutation({
    mutationFn: (token: string) => unwrap(api.POST('/newsletter/confirm', { body: { token } })),
  });
}

export function useUnsubscribe() {
  return useMutation({
    mutationFn: (token: string) => unwrap(api.POST('/newsletter/unsubscribe', { body: { token } })),
  });
}
